import { CircularProgress } from '@mui/material';
import { OrganisationCodeWorkflowSwitcher as OrganisationCodeWorkflowSwitcherComponent } from '@verifime/components';
import { TNotificationHandler } from '../../../types';
import { useOrganisationCodeWorkflow } from './hooks/useOrganisationCodeWorkflow';

export interface OrganisationCodeWorkflowSwitcherProps {
  organisationId: string;
  successNotificationHandler?: TNotificationHandler;
  errorNotificationHandler?: TNotificationHandler;
  noCodesMessage?: React.ReactNode;
}

export default function OrganisationCodeWorkflowSwitcher({
  organisationId,
  successNotificationHandler,
  errorNotificationHandler,
  noCodesMessage,
}: Readonly<OrganisationCodeWorkflowSwitcherProps>) {
  const {
    selectedCode,
    setSelectedCode,
    isLoading,
    handleWorkflowSwitch,
    organisationCodes,
    selectedWorkflow,
    disabledWorkflows,
  } = useOrganisationCodeWorkflow(
    organisationId,
    successNotificationHandler,
    errorNotificationHandler,
  );

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <OrganisationCodeWorkflowSwitcherComponent
      key={organisationId}
      selectedWorkflow={selectedWorkflow}
      onClick={handleWorkflowSwitch}
      organisationCodes={organisationCodes}
      selectedCode={selectedCode}
      onCodeChange={setSelectedCode}
      disabledWorkflows={disabledWorkflows}
      noCodesMessage={noCodesMessage}
    />
  );
}
